<template>
  <article class="crm-timeline-item">
    <span class="crm-timeline-dot" :class="dotClass"></span>
    <div class="crm-timeline-content">
      <div class="crm-timeline-title-row">
        <strong>{{ title }}</strong>
        <small>{{ dateText }}</small>
      </div>
      <p v-if="description" class="crm-timeline-description">
        {{ description }}
      </p>
      <div class="crm-timeline-meta">
        <span>{{ user || "CRM" }}</span>
        <span v-if="type" class="crm-timeline-type">{{ type }}</span>
      </div>
      <div v-if="$slots.actions" class="crm-timeline-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "CrmTimelineItem",
  props: {
    date: {
      type: [String, Date],
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
    user: {
      type: String,
      default: "",
    },
  },
  computed: {
    dateText() {
      return this.date ? new Date(this.date).toLocaleString("pt-BR") : "";
    },
    dotClass() {
      return {
        "is-success": this.status === "success",
        "is-danger": this.status === "danger",
        "is-warning": this.status === "warning",
      };
    },
  },
};
</script>

<style scoped>
.crm-timeline-item {
  display: grid;
  gap: 12px;
  grid-template-columns: 16px 1fr;
  position: relative;
}

.crm-timeline-item::before {
  background: #e4e9f1;
  bottom: -10px;
  content: "";
  left: 7px;
  position: absolute;
  top: 24px;
  width: 1px;
}

.crm-timeline-dot {
  background: #0b87c9;
  border: 3px solid #eaf7ff;
  border-radius: 50%;
  height: 14px;
  margin-top: 5px;
  width: 14px;
}

.crm-timeline-dot.is-success {
  background: #1bc5bd;
  border-color: #e8fff3;
}

.crm-timeline-dot.is-danger {
  background: #f64e60;
  border-color: #fff2f5;
}

.crm-timeline-dot.is-warning {
  background: #ffa800;
  border-color: #fff8dd;
}

.crm-timeline-content {
  background: #ffffff;
  border: 1px solid #e4e9f1;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(23, 31, 56, 0.04);
  padding: 13px 14px;
}

.crm-timeline-title-row {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.crm-timeline-description {
  white-space: pre-wrap;
  word-break: break-word;
}

.crm-timeline-title-row strong {
  color: #25324b;
  font-size: 14px;
  font-weight: 800;
}

.crm-timeline-title-row small,
.crm-timeline-meta {
  color: #7b8499;
  font-size: 12px;
}

.crm-timeline-content p {
  color: #4d5a70;
  font-size: 13px;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.crm-timeline-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.crm-timeline-type {
  background: #eef4fb;
  border-radius: 999px;
  color: #52637a;
  font-weight: 800;
  padding: 2px 8px;
}

.crm-timeline-actions {
  margin-top: 8px;
}

@media (max-width: 575px) {
  .crm-timeline-title-row {
    display: block;
  }

  .crm-timeline-title-row small {
    display: block;
    margin-top: 3px;
  }
}
</style>
